export const API_BASE_URL = "https://api.nasa.gov/mars-photos/api/v1"
export const API_KEY = "LLHHzP5rFGmRNN0PuPC5iRqhJqVBA6FN43mud1tz"
